import descriptions from './book-descriptions-de.json';
import aliases from './book-description-aliases.json';
import audiobookDescriptions from './audiobook-descriptions-published-de.json';
import editorialDescriptions from './audiobook-descriptions-editorial-de.json';
import bookEditorialDescriptions from './book-descriptions-editorial-de.json';

const germanDescriptions: Record<string, string> = { ...descriptions, ...audiobookDescriptions, ...editorialDescriptions, ...bookEditorialDescriptions };

export function bookDescription(title: string, original: string, language: 'en' | 'de'): string {
  if (language === 'en') return original || 'An audiobook from the Alex Anders collection.';
  const sourceTitle = (aliases as Record<string, string>)[title] || title;
  return germanDescriptions[sourceTitle] || original || 'Ein Hörbuch aus der Alex-Anders-Sammlung.';
}
